export default {
   gGetSpreadSheetData: (state, getters, rootState) => (id) => {
     const dataSource = state.dataSources.find(dataSource => dataSource.id === id);
     return dataSource;
   }
}
